import { render } from "./kaihuSuccess.vue?vue&type=template&id=1f1cfb84&scoped=true"
import script from "./kaihuSuccess.vue?vue&type=script&lang=js"
export * from "./kaihuSuccess.vue?vue&type=script&lang=js"

import "./kaihuSuccess.vue?vue&type=style&index=0&id=1f1cfb84&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1cfb84"]])

export default __exports__